

export interface Position {
    lat: number,
    lng: number
}

export interface DealerSearchData{
    distance:number,
    id:number,
    lat:string,
    lng:string,
    detail:{
        "rizoma_id" : string,
        "company":string,
        "address": string,
        "city":string,
        "country_code": string,
        "country":string,
        "region":string,
        "zip":string,
        "phone":string,
        "fax": string,
        "email": string,
        "web":string,
    }
}


class DealerService{

    private readonly searchUrl:string;
    private readonly maxResult:number;

    constructor() {
        this.searchUrl = (window as any).rz_store_locator.search_url;
        this.maxResult = (window as any).rz_store_locator.search_max_result;
    }


    search = async (position:Position, type:string, query:string):Promise<DealerSearchData[]> =>{
        const url = this.searchUrl+`?lat=${position.lat}&lng=${position.lng}&total=${this.maxResult}&type=${type}&q=${encodeURIComponent(query)}`;
        const response  = await  fetch(url);
        if (!response.ok) throw new Error(`Response status: ${response.status}`);
        return await response.json();
    }
}

const service = new DealerService();
export default service;
